
export const ProductTexts = {
  Product: {
    title:{
      ko: (<>세계적으로 검증된 최고 수준의 보안 솔루션</>),
      en: (<>World-class security solutions validated globally</>)
    },
    subtitle:{
      ko: (<>최첨단 기술로 구현된 차세대 보안 솔루션을 만나보세요</>),
      en: (<>Experience next-generation security solutions implemented with cutting-edge technology</>)
    }
  },
  Halcyon: {
    title:{
      ko: (<>(미국 제품)<br/>암호화 키 가로채기<br/>Anti-랜섬웨어 솔루션</>),
      en: (<>Anti-Ransomware Solution</>)
    },
    message: {
      ko: (
        <>
          랜섬웨어 공격 시 이를 실시간으로 정면 돌파하여  해커의 공격 암호화 key를  직접 가로채  데이터를 즉시 복원하는  솔루션!<br/>
          핵심 데이터를 랜섬웨어 위협으로부터 보호하고, 몸값 지불 협박을 개의치 않고 랜썸 지급 없이 안정된 업무 환경 제공!
        </>
      ),
      en: (
        <>
          A solution that directly intercepts the attacker's encryption key
          in real-time during a ransomware attack to immediately restore data!
          Protects critical data from ransomware threats,
          providing a stable work environment without paying ransoms or succumbing to extortion demands!
        </>
      )
    },
  },
  Primxtitle: {
    title:{
      ko: (<>(프랑스 제품)<br/>DRM 과 차원이 다른<br/>초고속 암호화 솔루션</>),
      en: (<>Ultra-Fast Encryption Solution</>)
    },
    message: {
      ko: (
        <>
          지정한 안전지대의 모든 파일을 초고속으로 암호화하는 솔루션!<br/>
          파일의 종류와 크기와 상관없이 암호화를 적용해, 외부 공격으로부터 파일을원천적으롶 가장 안전하게 보호, 관리!
        </>
      ),
      en: (
        <>
          A solution that ultra-fast encrypts all files in designated safe zones!
          Applies encryption regardless of file type and size,
          fundamentally protecting and managing files from external attacks in the safest way!
        </>
      )
    },
  },
  Kosmos: {
    title:{
      ko: (<>(미국 제품)<br/>Block Chain에 기반한<br/>LiveID 인증 솔루션</>),
      en: (<>LiveID Authentication Solution</>)
    },
    message: {
      ko: (
        <>
          비밀번호 없이 생동적 얼굴인식(LiveID)으로 진짜 본인을 정확히 확인하는 인증 솔루션!<br/>
          확실한 본인 확인이 필요한 모든 업무 환경에 적용 가능하며, 사용자 편의성과  철저한 개인정보 보호를 동시에 제공!
        </>
      ),
      en: (
        <>
          An authentication solution that accurately verifies the real identity
          through dynamic facial recognition (LiveID) without passwords!
          Applicable to all work environments requiring reliable identity verification,
          providing both user convenience and thorough personal information protection!
        </>
      )
    },
  },
  ObserveIT: {
    title:{
      ko: (<>(미국 제품)<br/>모든 행위를 녹화하는<br/>내부자 위협 관리 솔루션</>),
      en: (<>Insider Threat Management Solution</>)
    },
    message: {
      ko: (
        <>
          사용자의 모든 행위를 녹화하여 내부자 위협을 사전에 탐지하는 관리 솔루션!<br/>
          위협 가능성을 조기에 인지하고, 보안 사고 발생 시 원인을 신속히 분석하여 IT 자산을 안전하게 보호!

        </>
      ),
      en: (
        <>
          A management solution that records all user activities to detect insider threats in advance!
          Early recognition of potential threats and swift analysis of causes in case of security incidents,
          ensuring the safety of IT assets!
        </>
      )
   },
  },
  Mobileum: {
      title:{
        ko: (<>(미국 제품)<br/>통신사를 위한 <br/>전문 보안 솔루션</>),
        en: (<>Telecom Security Solution</>)
      },
      message: {
        ko: (
          <>
            Mobileum은 통신 인프라 전반을 실시간으로 가시화하고,<br/>
            통신사(SKT, KT, LGU+)의 사기·공격·품질 저하를 사전에 차단하는 글로벌 통신 보안 플랫폼!
          </>
        ),
        en: (
          <>
            Mobileum is a global telecom security platform that visualizes the entire telecom infrastructure in real-time,
            preventing fraud, attacks, and quality degradation in advance!
          </>
        )
      }
  },
  Detailbtn: {
      ko: (<>자세히 보기</>),
      en: (<>Read More</>)
  }

};

